import { createCtx } from '@mi-front/core';

export type RecordCtx<R> = R;

export const [_useRecordCtx, RecordCtxProvider] = createCtx<RecordCtx<any>>();

export function useRecord<R>() {
  return _useRecordCtx() as RecordCtx<R>;
}
